import { render, staticRenderFns } from "./ProjectSubmissionList.vue?vue&type=template&id=5a1e470e&scoped=true&"
import script from "./ProjectSubmissionList.vue?vue&type=script&lang=js&"
export * from "./ProjectSubmissionList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSubmissionList.vue?vue&type=style&index=0&id=5a1e470e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1e470e",
  null
  
)

export default component.exports